import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { ComplaintFormValues } from "../types";
import { ComplaintType } from "../ComplaintTypeSelector";
import { useTextColorClass } from "@/components/ui/text-coloring";
import { SupportCaseFileUpload } from "../SupportCaseFileUpload";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";
import { ComplaintFollowUpFields } from "../ComplaintFollowUpFields";
import { categoryHasFollowUps } from "../complaintFollowUpCatalog";

interface DetailsStepProps {
  form: UseFormReturn<ComplaintFormValues>;
  selectedType: ComplaintType | null;
  files: File[];
  onFilesChange: (files: File[]) => void;
}

export const DetailsStep = ({
  form,
  selectedType,
  files,
  onFilesChange,
}: DetailsStepProps) => {
  const { baseText, placeholderText, isDark } = useTextColorClass();
  const labels = supportLabels(getLanguage());
  const categoryId = selectedType?.id;

  return (
    <div className="space-y-3">
      {categoryHasFollowUps(categoryId) && (
        <ComplaintFollowUpFields form={form} categoryId={categoryId} />
      )}

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel className={`${baseText} text-sm`}>
              {labels.problemDescriptionLabel}
            </FormLabel>
            <FormControl>
              <Textarea
                placeholder={labels.describeProblemPlaceholder}
                className={`min-h-[80px] sm:min-h-[100px] ${
                  isDark
                    ? "bg-black/20 border-white/20 text-white"
                    : "bg-white border-gray-200 text-black"
                } ${placeholderText} text-xs sm:text-sm py-1.5`}
                {...field}
              />
            </FormControl>
          </FormItem>
        )}
      />

      <SupportCaseFileUpload
        files={files}
        onFilesChange={onFilesChange}
        title={labels.uploadProblemImages}
      />
    </div>
  );
};
